import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { BuyerSupplierService } from '../../../services/buyer-supplier.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-auto-po-modal',
  templateUrl: './auto-po-modal.component.html',
  styleUrls: ['./auto-po-modal.component.scss']
})
export class AutoPoModalComponent implements OnInit {

  public title !: string;
  public prId !: string;
  public createPOForm !: FormGroup;
  public taxCodeList: any;
  public vendor_details !: [];

  constructor(private _formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private _buyerSupplierService: BuyerSupplierService,
    private _toastrService: ToastrService,
    private _buyerHelperService: PrBuyerHelperService) {
      this.createPOForm = this._formBuilder.group({
        sales_order: [''],
        sales_item_no: [''],
        service_line_item_no: [''],
        tax_code: [null, [Validators.required]]
      });
     }

  ngOnInit(): void {
    this.getTaxCode();
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public createPO() {
    const body = this.createPOForm.getRawValue();
    body.prId = this.prId;
    body.vendor_details = this.vendor_details
    this._buyerSupplierService.createAutoPO(body).subscribe((res: IAPIResponse<any>) => {
      this._toastrService.success(res.message);
      this.onModalClose();
    }, (err: any) => {
        this._buyerHelperService.failedPOCreationModal(err.error);
    });
  }

  private getTaxCode() {
    this._buyerSupplierService.getTaxCodes().subscribe((res: IAPIResponse<any>) => {
      this.taxCodeList = res.data;
      this._toastrService.success(res.message);
    }, (err: any) => {
        this._buyerHelperService.failedPOCreationModal(err.error);
      });
  }

}
